module.exports = __webpack_public_path__ + "img/item6-2.98613bf5.jpg";